import { Encumbrance } from '@models/encumbrance';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
	MatterTitle,
} from '@models/matter';
import { MatterMortgageWithAssociations } from '@models/mortgage';
import { Selector } from '@ngxs/store';
import { MatterClients } from 'src/app/shared/state/global/matter_clients';
import { TitlePlusState } from 'src/app/shared/state/global/title-insurance/title-plus/title-plus.state';
import { MatterEncumbrancesState } from 'src/app/shared/state/matter/encumbrances';
import { SelectedMatter } from 'src/app/shared/state/matter/matter.selectors';
import { MatterMortgagesState } from 'src/app/shared/state/matter/matter_mortgages';
import { MatterTitlesState } from 'src/app/shared/state/matter/titles/titles.state';
import { UserProfileState } from 'src/app/shared/state/user-profile';

export interface TitlePlusSelectorProps {
	matter: Matter;
	clients: (PersonMatterClient | BusinessMatterClient)[];
	mortgages: MatterMortgageWithAssociations[];
	remainEncumbrances: Encumbrance[];
	matterTitles: MatterTitle[];
	phoneNumber: string;
	lawyerConnected: boolean;
}

export class TitlePlusViewModel {
	@Selector([
		SelectedMatter.getSelected,
		MatterClients.get_mortgagorsWithAssociationMapped,
		MatterMortgagesState.getAllMortgagesWithAssociations,
		MatterEncumbrancesState.getRemain,
		MatterTitlesState.getAll,
		UserProfileState.phoneNumber,
		TitlePlusState.lawyerConnected,
	])
	static titlePlusPayloadProps(
		matter: Matter,
		clients: (PersonMatterClient | BusinessMatterClient)[],
		mortgages: MatterMortgageWithAssociations[],
		remainEncumbrances: Encumbrance[],
		matterTitles: MatterTitle[],
		phoneNumber: string,
		lawyerConnected: boolean,
	): TitlePlusSelectorProps {
		return {
			matter,
			clients,
			mortgages,
			remainEncumbrances,
			matterTitles,
			phoneNumber,
			lawyerConnected,
		};
	}
}
